import { apiSlice } from './apiSlice.js';
import { ORDERS_URL } from '../constants.js';

export const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    initiateRazorPayOrder: builder.mutation({
      query: (orderItems) => ({
        url: `${ORDERS_URL}/razorpay-initiate`,
        method: 'POST',
        body: { orderItems }
      })  
    }),
    createOrder: builder.mutation({
      query: (order) => ({
        url: ORDERS_URL,
        method: 'POST',
        body: order
      })
    }),
    getOrderDetails: builder.query({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}`
      }),
      keepUnusedDataFor: 5
    }),
    createRazorPayOrder: builder.mutation({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/razorpay`,
        method: 'POST'
      })
    }),
    payOrder: builder.mutation({
      query: ({orderId, details}) => ({
        url: `${ORDERS_URL}/${orderId}/pay`,
        method: 'PUT',
        body: {...details}
      })
    }),
    getUserOrders: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/userorders`
      }),
      keepUnusedDataFor: 5
    }),
    getOrders: builder.query({
      query: () => ({
        url: ORDERS_URL
      }),
      keepUnusedDataFor: 5
    }),
    updateOrderDelivery: builder.mutation({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/deliver`,
        method: "PUT"
      })
    }),
    updatePreferredDelivery: builder.mutation({
      query: ({orderId, preferredDeliveryDateOffset, preferredDeliveryTimeSlot}) => ({
        url: `${ORDERS_URL}/${orderId}/preferred-delivery`,
        method: "PUT",
        body: {preferredDeliveryDateOffset, preferredDeliveryTimeSlot}
      })
    }),
    createOrderReview: builder.mutation({
      query: ({orderId, rating, comment}) => ({
        url: `${ORDERS_URL}/${orderId}/orderreview`,
        method: "POST",
        body: {rating, comment}
      })
    }),
    createOrderedProductReview: builder.mutation({
      query: ({orderId, rating, comment, productId}) => ({
        url: `${ORDERS_URL}/${orderId}/${productId}/productreview`,
        method: "POST",
        body: {rating, comment, productId}
      })
    }),
    getOrderReviewById: builder.query({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/orderreview`
      }),
      keepUnusedDataFor: 5
    }),
    getOrderedProductReviewsById: builder.query({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/productreviews`
      }),
      keepUnusedDataFor: 5
    }),
    assignDeliveryPartner: builder.mutation({
      query: ({ orderId, deliveryPartnerUserId }) => ({
        url: `${ORDERS_URL}/${orderId}/deliverypartner`,
        method: 'PUT',
        body: { deliveryPartnerUserId },
      }),
      invalidatesTags: ['Order'],
    }),
    getDeliveryPartnerOrders: builder.query({
      query: (status) => ({
        url: `${ORDERS_URL}/deliverypartner?status=${status}`,
      }),
      providesTags: ['Orders'],
    }),
    assignSourcingPartner: builder.mutation({
      query: ({ orderId, sourcingPartnerUserId, sourcingPartnerAddressId }) => ({
        url: `${ORDERS_URL}/${orderId}/sourcingpartner`,
        method: 'PUT',
        body: { sourcingPartnerUserId, sourcingPartnerAddressId },
      }),
      invalidatesTags: ['Order'],
    }),
    updateOrderCollection: builder.mutation({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/collect`,
        method: "PUT"
      })
    })
  })
})

export const {
  useInitiateRazorPayOrderMutation,
  useCreateOrderMutation,
  useGetOrderDetailsQuery,
  useCreateRazorPayOrderMutation,
  usePayOrderMutation,
  useGetUserOrdersQuery,
  useGetOrdersQuery,
  useUpdateOrderDeliveryMutation,
  useUpdatePreferredDeliveryMutation,
  useCreateOrderReviewMutation,
  useCreateOrderedProductReviewMutation,
  useGetOrderReviewByIdQuery,
  useGetOrderedProductReviewsByIdQuery,
  useAssignDeliveryPartnerMutation,
  useGetDeliveryPartnerOrdersQuery,
  useAssignSourcingPartnerMutation,
  useUpdateOrderCollectionMutation
} = ordersApiSlice;